import { ArticleView } from "@serophin/nottldr-shared";
import { useArticleList } from "@serophin/nottldr-shared/hooks";
import { ArticleList } from "../../components/feed/ArticleList";
import { ProfileTabs } from "../../components/profile/ProfileTabs";
import type { PageProps } from "../pageProps";
import { useRequireSession } from "./useRequireSession";

const EMPTY = "Looks like you haven't read any articles yet. Start exploring articles and they'll appear here as you read them!";

const History = () => {
  const list = useArticleList(ArticleView.READ, undefined, "read");
  return <ArticleList list={list} emptyMessage={EMPTY} />;
};

/** `/profile`: the articles the visitor has read. */
export const HistoryPage = (_props: PageProps) => {
  const allowed = useRequireSession();
  return allowed ? (
    <>
      <ProfileTabs active="read" />
      <History />
    </>
  ) : null;
};
